/**
 * Filmssavn - Main Application Entry Point
 * Faroese Originals. Streaming Everywhere.
 */

import '../src/styles/design-system.css';
import { initI18n } from './lib/i18n.js';
import { initKeycloak } from './lib/keycloak.js';
import { router } from './lib/router.js';
import { renderAbout } from './pages/about.js';
import { renderBrowse } from './pages/browse.js';
import { renderCallback } from './pages/callback.js';
import { renderHome } from './pages/home.js';
import { renderMyRentals } from './pages/my-rentals.js';
import { renderPrivacy } from './pages/privacy.js';
import { renderSearch } from './pages/search.js';
import { renderTerms } from './pages/terms.js';
import { cleanup as cleanupWatch, renderWatch } from './pages/watch.js';

// Configure routes
router.addRoute('/', async () => {
  cleanupWatch();
  await renderHome();
});

router.addRoute('/browse', async () => {
  cleanupWatch();
  await renderBrowse();
});

router.addRoute('/watch/:id', async (params) => {
  await renderWatch(params);
});

router.addRoute('/my-rentals', async () => {
  cleanupWatch();
  await renderMyRentals();
});

router.addRoute('/callback', async () => {
  await renderCallback();
});

router.addRoute('/terms', async () => {
  cleanupWatch();
  await renderTerms();
});

router.addRoute('/privacy', async () => {
  cleanupWatch();
  await renderPrivacy();
});

router.addRoute('/about', async () => {
  cleanupWatch();
  await renderAbout();
});

router.addRoute('/search', async () => {
  cleanupWatch();
  await renderSearch();
});

// Initialize application
document.addEventListener('DOMContentLoaded', async () => {
  console.log('%c🎬 STROYMA', 'font-size: 24px; font-weight: bold; color: #0077C0;');
  console.log('Faroese Originals. Streaming Everywhere.');

  // Initialize i18n (with automatic location detection)
  await initI18n();

  // Initialize Keycloak (check for existing session)
  await initKeycloak();

  // Start router
  router.init();
});

// Handle page visibility for video playback
document.addEventListener('visibilitychange', () => {
  if (document.hidden && window.currentPlayer) {
    // Pause playback when tab is hidden
    try {
      window.currentPlayer.pause();
    } catch (e) {
      console.warn('Failed to pause player:', e);
    }
  }
});

// Clean up on page unload
window.addEventListener('beforeunload', () => {
  cleanupWatch();
});
